/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { useLoadScript } from '@react-google-maps/api';
import styled from 'styled-components';

import Store from '../../utils/Store';
import SearchBoxOne from './SearchBoxOne';
import SearchBoxTow from './SearchBoxTwo';
import MapWrapper from './MapWrapper';
import Distance from './Distance';

import { transports } from '../../utils/data';

const libraries = ['places'];
const Destination = () => {
	const { state } = useContext(Store);
	let { origin, destination, transport } = state;

	// console.log('From app store state value', state);
	// console.log('From app str', startLatLng);
	// console.log('From app end', endLatLng);

	const [originLatLng, setOriginLatLng] = useState([]);
	const [distLatLng, setDistLatLng] = useState([]);
	const [distance, setDistance] = useState('');
	const [selectedTransport, setSelectedTransport] = useState({
		img: null,
		speed: 0,
		fair: 0,
	});

	const { isLoaded, loadError } = useLoadScript({
		googleMapsApiKey: process.env.REACT_APP_API_KEY,
		libraries,
	});

	useEffect(() => {
		setOriginLatLng(origin);
	}, [origin]);

	useEffect(() => {
		setDistLatLng(destination);
	}, [destination]);

	useEffect(() => {
		setSelectedTransport(transport);
	}, [transport]);

	if (loadError) return 'Error';
	if (!isLoaded) return 'Loading...';

	function calculateTime(distance, speed) {
		//  calculate time
		let hourValue = distance / speed;
		let fixedHourValue = Number.parseFloat(hourValue).toFixed(2);
		let hour = Number(fixedHourValue.slice(0, -2));
		let minutes = Number(fixedHourValue.slice(-2));
		let time = `About ${hour} hours and ${minutes} minutes`;
		return time;
	}

	function calculateCost(distance, fair) {
		let newCost = distance * fair;
		let fixedCost = Number.parseFloat(newCost).toFixed(2);
		return fixedCost;
	}

	const time = calculateTime(distance, selectedTransport.speed);
	// console.log('From App.js', 'origin =', origin, 'destination =', destination);
	const getDistance = async (d) => {
		await setDistance(d);
		// console.log('app dis', d);
	};

	const cost = calculateCost(distance, selectedTransport.fair);

	// select transport
	const selectTransportHandler = (id) => {
		const selectTransport = transports.find((transport) => transport.id === id);
		setSelectedTransport(selectTransport);
	};

	return (
		<Wrapper>
			<div>
				<SearchWrapper>
					<SearchBoxOne />
					<SearchBoxTow />
				</SearchWrapper>

				<TransportContainer>
					<h3>Please Select Your Transport</h3>
					<BoxWrapper>
						{transports.map((transport) => {
							const { id, img, transportsType } = transport;
							return (
								<Box key={id} onClick={() => selectTransportHandler(id)}>
									<img src={img} alt={transportsType} />
								</Box>
							);
						})}
					</BoxWrapper>
				</TransportContainer>
				{selectedTransport ? (
					<TransportDetails>
						<div id='price'>
							<img src={selectedTransport.img} alt='' />
							<p>BDT {cost}</p>
						</div>
						<p>{time}</p>
						Distance:
						<Distance
							originLatLng={originLatLng}
							distLatLng={distLatLng}
							getDistanceValue={getDistance}
						/>
					</TransportDetails>
				) : null}
			</div>

			<div>
				<MapWrapper
					originLatLng={originLatLng}
					distLatLng={distLatLng}
					getDistance={getDistance}
				/>
			</div>
		</Wrapper>
	);
};

export default React.memo(Destination);
const Wrapper = styled.div`
	width: 100vw;
	padding: 50px;
	display: grid;
	grid-template-columns: 1fr 3fr;
	grid-column-gap: 20px;

	@media screen and (max-width: 800px) {
		grid-template-columns: 1fr;
	}
`;

const SearchWrapper = styled.div`
	background: #efefef;
	padding: 10px;
	display: grid;
	justify-content: center;
	align-items: center;
	border-radius: 4px;
`;

const TransportContainer = styled.div`
	text-align: center;
	margin-top: 10px;
	background: #efefef;
`;

const BoxWrapper = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: repeat(auto-fit, 60px);
	grid-gap: 10px;
	justify-content: center;
	align-items: center;
	padding: 10px 0;
`;
const Box = styled.div`
	background: #fff;
	padding: 10px;
	border-radius: 4px;
	cursor: pointer;
	img {
		width: 40px;
		height: 40px;
	}
`;

const TransportDetails = styled.div`
	margin: 20px 0;
	background: #efefef;
	text-align: center;

	img {
		width: 40px;
		height: 40px;
	}

	#price {
		display: flex;
		justify-content: space-between;
		padding: 10px;
	}
`;
